import * as types from '../mutation-types'

const state = {
  showInvitationMenu: false,
  showPatientMenu: false,
  showDoctorMenu: false,
  showPressConferenceMenu: false,
}

const getters = {
  showMenu: state => state.showMenu
}

const actions = {
  togglePatientMenu ({commit}) {
    commit(types.TOGGLE_PATIENT_MENU)
  },
  toggleDoctorMenu ({commit}) {
    commit(types.TOGGLE_DOCTOR_MENU)
  },
  togglePressConferenceMenu ({commit}) {
    commit(types.TOGGLE_PRESS_CONFERENCE_MENU)
  },
  toggleInvitationMenu ({commit}) {
    commit(types.TOGGLE_INVITATION_MENU)
  }
}

const mutations = {
  [types.TOGGLE_PATIENT_MENU] (state) {
    state.showPatientMenu = !state.showPatientMenu
  },
  [types.TOGGLE_DOCTOR_MENU] (state) {
    state.showDoctorMenu = !state.showDoctorMenu
  },
  [types.TOGGLE_PRESS_CONFERENCE_MENU] (state) {
    state.showPressConferenceMenu = !state.showPressConferenceMenu
  },
  [types.TOGGLE_INVITATION_MENU] (state) {
    state.showInvitationMenu = !state.showInvitationMenu
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js